module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _c('div', {
    staticClass: "goods-diy-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, _vm._l((_vm.diyImages), function(item, index) {
    return _c('div', {
      staticClass: "img-box",
      style: ({
        'z-index': item.imageIndex
      })
    }, [_c('img', {
      attrs: {
        "src": _vm.imagePath(item.sku && item.sku.diyImage && item.sku.diyImage.imagePath),
        "alt": ""
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-type"
  }, _vm._l((_vm.selectDIYinfo), function(item) {
    return _c('div', {
      staticClass: "typeItem"
    }, [_c('label', [_vm._v(_vm._s(item.fieldName) + "：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.valueName))])])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "mx-mall-type"
  }, [_vm._l(((_vm.diyPropertys && _vm.diyPropertys.items)), function(diyProperty, index) {
    return [_vm._l(((diyProperty.itemInfo && diyProperty.itemInfo.fields)), function(item, i) {
      return _c('li', {
        staticClass: "type-list",
        class: {
          active: _vm.typeId == i + 'field'
        }
      }, [(diyProperty.itemType == 1) ? [_c('div', {
        staticClass: "head",
        on: {
          "click": function($event) {
            _vm.typeId = i + 'field'
          }
        }
      }, [_vm._v(_vm._s(item.fieldName))]), _vm._v(" "), _c('div', {
        staticClass: "type-box"
      }, _vm._l((item.values), function(info) {
        return _c('div', {
          staticClass: "img-box",
          class: {
            active: info.isChecked == 1
          },
          on: {
            "click": function($event) {
              return _vm.selectDiyGood(index, diyProperty.goodsId, item.fieldId, info.valueId, diyProperty.imageIndex)
            }
          }
        }, [(info.imagePath) ? _c('imgs', {
          attrs: {
            "imagePath": info.imagePath && info.imagePath.imagePath
          }
        }) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(info.valueName))])], 1)
      }), 0)] : _vm._e()], 2)
    }), _vm._v(" "), _c('li', {
      staticClass: "type-list",
      class: {
        active: _vm.typeId == index
      }
    }, [(diyProperty.itemType == 2) ? [_c('div', {
      staticClass: "head",
      on: {
        "click": function($event) {
          _vm.typeId = index
        }
      }
    }, [_vm._v(_vm._s(diyProperty.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "type-box"
    }, _vm._l((diyProperty.itemInfo), function(info) {
      return _c('div', {
        staticClass: "img-box",
        class: {
          active: info.isChecked == 1
        },
        on: {
          "click": function($event) {
            return _vm.selectDiyProperty(index, info.skuId)
          }
        }
      }, [_c('imgs', {
        attrs: {
          "imagePath": info.diyImage && info.diyImage.imagePath
        }
      })], 1)
    }), 0)] : _vm._e()], 2)]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "number-box"
  }, [_c('div', {
    staticClass: "floatL"
  }, [_vm._v("数量")]), _vm._v(" "), _c('div', {
    staticClass: "floatR"
  }, [_c('div', {
    staticClass: "goods-number"
  }, [_c('span', {
    staticClass: "add-btn",
    on: {
      "click": function($event) {
        return _vm.changegoodsNum('reduce')
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goodsNum),
      expression: "goodsNum"
    }],
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.goodsNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.goodsNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "reduce-btn",
    on: {
      "click": function($event) {
        return _vm.changegoodsNum('add')
      }
    }
  }), _vm._v(" "), _c('samp', [_vm._v("套")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "utilPrice"
  }, [_c('div', {
    staticClass: "floatL"
  }, [_c('label', [_vm._v("优惠价")]), _vm._v(" "), _c('span', [_c('samp', [_vm._v("¥")]), _vm._v(_vm._s(_vm.skuInfo && _vm.skuInfo.goodsPrice.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "floatR"
  }, [_vm._v("售价 "), _c('span', [_vm._v("¥" + _vm._s(_vm.skuInfo && _vm.skuInfo.unitPrice.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "totalPrice"
  }, [_c('div', {
    staticClass: "floatL"
  }, [_c('label', [_vm._v("总价")]), _vm._v(" "), _c('span', [_c('samp', [_vm._v("¥")]), _vm._v(_vm._s(_vm.totalPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "floatR"
  }, [_vm._v("共 "), _c('span', [_vm._v(_vm._s(_vm.goodsNum))]), _vm._v(" 套")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bb7b780","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/classify/goodsDiy.vue
// module id = 409
// module chunks = 68